var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthiquinAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36.1,
    height: 36.1,
    viewBox: "0 0 36.1 36.1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_1",
    gradientUnits: "userSpaceOnUse",
    x1: 1.688,
    y1: 2.631,
    x2: 7.762,
    y2: 6.133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D7E1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    stopColor: "#CED9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678,
    stopColor: "#B7C5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFBEC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_2",
    gradientUnits: "userSpaceOnUse",
    x1: -0.001,
    y1: 0.906,
    x2: 2.052,
    y2: 0.906
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#FCFDFD",
    stopOpacity: 0.647
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#F4F6F8",
    stopOpacity: 0.435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#E6E9EF",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#D2D8E2",
    stopOpacity: 0.106
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC8D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_3",
    gradientUnits: "userSpaceOnUse",
    x1: 5.854,
    y1: 2.476,
    x2: -1.797,
    y2: 6.216
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D7E1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC8D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_4",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0.906,
    x2: 2.054,
    y2: 0.906
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#BFC8D6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#D2D8E2",
    stopOpacity: 0.106
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#E6E9EF",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    stopColor: "#F4F6F8",
    stopOpacity: 0.435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#FCFDFD",
    stopOpacity: 0.647
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_5",
    gradientUnits: "userSpaceOnUse",
    x1: 2.633,
    y1: 0.001,
    x2: 2.633,
    y2: 5.203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#007DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#015794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#013875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#021F5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649,
    stopColor: "#020E4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#020342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02003F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_6",
    gradientUnits: "userSpaceOnUse",
    x1: 2.071,
    y1: 0.112,
    x2: 2.071,
    y2: 5.637
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#99E9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#7FCFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#55A5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#3B8BFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3181FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_7",
    gradientUnits: "userSpaceOnUse",
    x1: 10.967,
    y1: 0,
    x2: 10.967,
    y2: 19.298
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D7E1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#CEDAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFCFE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_8",
    gradientUnits: "userSpaceOnUse",
    x1: 9.05,
    y1: 0,
    x2: 9.05,
    y2: 11.355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#013792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#012B44"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.416 26.617)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54782 3.33812C6.77741 2.74969 7.19834 1.70856 6.70882 0.69199C6.59764 0.462395 6.43952 0.14327 6.08574 0.0349697C5.22439 -0.224951 3.95728 1.03566 3.43961 1.4537C1.45627 3.05437 0.136458 5.19005 0 6.80949C1.40212 7.57481 2.9176 8.15891 4.51394 8.53146C5.28721 7.83762 5.25255 6.66726 6.54782 3.33812C6.54782 3.33812 6.54782 3.33812 6.54782 3.33812Z",
    fill: "url(#gradient_1)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0715864 0.00385141C0.486736 0.236336 0.867952 0.499865 1.21812 0.797329C1.57118 1.09768 1.84699 1.40742 2.04554 1.73593C2.0607 1.76048 2.05203 1.79152 2.03037 1.8038C2.00583 1.81896 1.97478 1.81029 1.9625 1.78864C1.76756 1.4724 1.50115 1.16555 1.15675 0.874583C0.80947 0.580008 0.434752 0.320088 0.0261 0.0941014C0.00155228 0.0818267 -0.00783408 0.0507813 0.00732839 0.0262332C0.0167148 0.0110722 0.0318761 0.00168562 0.0506489 0.00168562C0.0557023 -0.00192595 0.0650886 0.000962734 0.0715864 0.00385141C0.0715864 0.00385141 0.0715864 0.00385141 0.0715864 0.00385141Z",
    fill: "url(#gradient_2)",
    fillRule: "evenodd",
    transform: "translate(0.51 5.178)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.314 0.479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.49593 1.45386C2.97825 1.03582 1.71114 -0.22551 0.849797 0.0351327C0.496738 0.143433 0.338623 0.462558 0.226711 0.692153C-0.262805 1.70801 0.158843 2.74913 0.387718 3.33828C1.68443 6.67175 1.64833 7.84067 2.42376 8.53596C4.01938 8.16485 5.53341 7.5822 6.93553 6.81904C6.80341 5.19815 5.48287 3.05742 3.49593 1.45386C3.49593 1.45386 3.49593 1.45386 3.49593 1.45386Z",
    fill: "url(#gradient_3)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98158 0.00385141C1.56643 0.236335 1.18521 0.499865 0.835042 0.797328C0.481983 1.09768 0.20618 1.40742 0.00763035 1.73593C-0.00753117 1.76048 0.00113249 1.79152 0.0227919 1.8038C0.0473394 1.81896 0.0783849 1.81029 0.0906596 1.78863C0.285601 1.4724 0.552019 1.16555 0.896412 0.874583C1.24369 0.580008 1.61841 0.320087 2.02706 0.0941014C2.05161 0.0818267 2.061 0.0507813 2.04584 0.0262332C2.03645 0.0110722 2.02129 0.00168562 2.00252 0.00168562C2.00035 -0.00192595 1.99096 0.000962734 1.98158 0.00385141C1.98158 0.00385141 1.98158 0.00385141 1.98158 0.00385141Z",
    fill: "url(#gradient_4)",
    fillRule: "evenodd",
    transform: "translate(4.414 5.176)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.418 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38675 0.268855C7.48858 -0.0502699 6.69511 0.00893466 6.16516 0.00243693C6.16516 0.00243693 6.07202 0.00243693 6.07202 0.00243693C5.54568 0.00532554 4.74932 -0.0531563 3.85043 0.268855C3.60567 0.355496 2.91183 0.677507 2.33856 1.16125C1.09455 2.21248 0.353058 6.0203 0 8.38485C1.93857 9.0953 4.03165 9.48302 6.21498 9.48302C8.3687 9.48302 10.4343 9.10469 12.3498 8.41301C11.9325 6.23329 11.1145 2.76842 9.89862 1.16125C9.44665 0.56343 8.63151 0.355494 8.38675 0.268855C8.38675 0.268855 8.38675 0.268855 8.38675 0.268855Z",
    fill: "#D7E1EF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.582 1.805)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.22908 2.30665C5.52366 4.20912 3.99013 5.82929 2.18658 5.51666C1.09636 5.3275 0.216239 4.39828 0.0364602 3.24886C-0.258116 1.34639 1.27541 -0.27378 3.07897 0.0388476C4.16919 0.224402 5.04931 1.15434 5.22908 2.30665C5.22908 2.30665 5.22908 2.30665 5.22908 2.30665Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22908 2.2312C5.52366 4.07158 3.99013 5.63615 2.18658 5.3358C1.09636 5.15313 0.216239 4.25424 0.0364602 3.14236C-0.258116 1.30199 1.27541 -0.265475 3.07897 0.0377657C4.16919 0.220434 5.04931 1.1186 5.22908 2.2312C5.22908 2.2312 5.22908 2.2312 5.22908 2.2312Z",
    fill: "#476393",
    fillRule: "evenodd",
    fillOpacity: 0.95,
    transform: "translate(0 0.182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22908 2.16173C5.52366 3.94291 3.99013 5.45839 2.18658 5.1667C1.09636 4.98981 0.216239 4.1198 0.0364602 3.04113C-0.258116 1.25995 1.27541 -0.255522 3.07897 0.0361661C4.1728 0.213057 5.0522 1.08379 5.22908 2.16173C5.22908 2.16173 5.22908 2.16173 5.22908 2.16173Z",
    fill: "url(#gradient_5)",
    fillRule: "evenodd",
    transform: "translate(0 0.352)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.746 0.684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.87142C0 0.837865 0.833663 0 1.86204 0C2.89041 0 3.72408 0.837865 3.72408 1.87142C3.72408 2.90498 2.89041 3.74285 1.86204 3.74285C0.833663 3.74285 0 2.90498 0 1.87142Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "translate(0.004 0.332)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.88081 3.08944L0.644747 1.23029L1.88081 2.30823C1.88081 2.30823 3.37391 0.777593 3.37391 0.777593C3.03601 0.30685 2.4844 0 1.86204 0C0.833188 0 0 0.836797 0 1.87142C0 2.90605 0.833187 3.74285 1.86204 3.74285C2.89089 3.74285 3.72408 2.90605 3.72408 1.87142C3.72408 1.54003 3.63744 1.22668 3.48582 0.957373C3.48582 0.957373 1.88081 3.08944 1.88081 3.08944L1.88081 3.08944ZM1.88055 0.771484C2.11592 0.771484 2.30797 0.966425 2.30797 1.20829C2.30797 1.45016 2.11592 1.6451 1.88055 1.6451C1.64518 1.6451 1.45313 1.45016 1.45313 1.20829C1.45313 0.966425 1.64518 0.771484 1.88055 0.771484C1.88055 0.771484 1.88055 0.771484 1.88055 0.771484Z",
    fill: "#009CD7",
    transform: "translate(0 0.332)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.08444 0C1.08444 0 0 1.10899 0 1.10899C0.0404317 1.16458 0.0772545 1.22379 0.114798 1.28588C0.114798 1.28588 1.08444 0 1.08444 0L1.08444 0Z",
    fill: "#009CD7",
    fillRule: "evenodd",
    transform: "translate(3.375 0)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0.0261 1.20863C0.00155222 1.2209 -0.00783408 1.25195 0.00732839 1.27649C0.0196023 1.30104 0.0506488 1.31043 0.0751965 1.29527C1.53147 0.498902 2.98774 0.0996363 4.4433 0.0996363C5.89957 0.0996363 7.35584 0.499625 8.8114 1.29527C8.83594 1.30754 8.86699 1.29816 8.87926 1.27649C8.89154 1.25195 8.88215 1.2209 8.86049 1.20863C7.38906 0.402875 5.9169 0 4.44257 0C2.96825 0 1.49826 0.402875 0.0261 1.20863C0.0261 1.20863 0.0261 1.20863 0.0261 1.20863Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "translate(1.646 1.402)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.082 2.527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.14211 2.04832C4.14211 2.96526 3.55369 3.72769 2.73566 4.00638C2.73566 4.00638 2.73566 5.56807 2.73566 5.56807L1.36314 5.57096C1.36314 5.57096 1.36314 4.00927 1.36314 4.00927C0.566771 3.71831 0 2.95299 0 2.05121C0 0.901785 0.926326 6.88553e-06 2.07286 6.88553e-06C3.21218 -0.00288091 4.14211 0.898897 4.14211 2.04832C4.14211 2.04832 4.14211 2.04832 4.14211 2.04832Z",
    fill: "url(#gradient_6)",
    fillRule: "evenodd",
    transform: "translate(8.898 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9672 0C4.91032 0 0 4.91032 0 10.9672C0 10.9672 0 13.0148 0 13.0148C0 16.4847 2.81291 19.2976 6.28284 19.2976C6.28284 19.2976 15.6515 19.2976 15.6515 19.2976C19.1214 19.2976 21.9344 16.4847 21.9344 13.0148C21.9344 13.0148 21.9344 10.9672 21.9344 10.9672C21.9344 4.91032 17.024 0 10.9672 0C10.9672 0 10.9672 0 10.9672 0Z",
    fill: "url(#gradient_7)",
    fillRule: "evenodd",
    transform: "translate(0 5.539)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.916 10.404)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.50842e-07 8.14488C5.50842e-07 10.2885 1.73786 12.03 3.88508 12.03C3.88508 12.03 14.2176 12.03 14.2176 12.03C16.3612 12.03 18.1027 10.2921 18.1027 8.14488C18.1027 8.14488 18.1027 5.34136 18.1027 5.34136C18.1027 2.39199 15.7107 0 12.7614 0C12.7614 0 5.34136 0 5.34136 0C2.39199 0 0 2.39199 0 5.34136C0 5.34136 0 8.14488 0 8.14488C0 8.14488 5.50842e-07 8.14488 5.50842e-07 8.14488Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000721603 5.36879C0.000721603 2.40354 2.40498 0 5.36951 0C5.36951 0 12.731 0 12.731 0C15.6963 0 18.0998 2.40426 18.0998 5.36879C18.0998 5.36879 18.0998 8.11383 18.0998 8.11383C18.0998 10.2762 16.3497 12.0271 14.1866 12.0271C14.1866 12.0271 3.91324 12.0271 3.91324 12.0271C1.75085 12.0271 0 10.2769 0 8.11383C0 8.11383 0.000721603 5.36879 0.000721603 5.36879C0.000721603 5.36879 0.000721603 5.36879 0.000721603 5.36879Z",
    fill: "#476393",
    fillRule: "evenodd",
    transform: "translate(0 0.186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000721603 5.36879C0.000721603 2.40354 2.40498 0 5.36951 0C5.36951 0 12.731 0 12.731 0C15.6963 0 18.0998 2.40426 18.0998 5.36879C18.0998 5.36879 18.0998 7.44165 18.0998 7.44165C18.0998 9.60404 16.3497 11.3549 14.1866 11.3549C14.1866 11.3549 3.91324 11.3549 3.91324 11.3549C1.75085 11.3549 0 9.60477 0 7.44165C0 7.44165 0.000721603 5.36879 0.000721603 5.36879L0.000721603 5.36879C0.000721603 5.36879 0.000721603 5.36879 0.000721603 5.36879Z",
    fill: "url(#gradient_8)",
    fillRule: "evenodd",
    transform: "translate(0 0.871)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.445 4.156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.28438C0 3.85476 0.461359 4.31612 1.03174 4.31612C1.03174 4.31612 1.28877 4.31612 1.28877 4.31612C1.85915 4.31612 2.32051 3.85476 2.32051 3.28438C2.32051 3.28438 2.32051 1.03174 2.32051 1.03174C2.32051 0.461358 1.85915 0 1.28877 0C1.28877 0 1.03174 0 1.03174 0C0.461359 0 0 0.461358 0 1.03174C0 1.03174 0 3.28438 0 3.28438C0 3.28438 0 3.28438 0 3.28438Z",
    fill: "#F3FCFF",
    fillRule: "evenodd",
    fillOpacity: 0.9,
    transform: "translate(8.893 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.28438C0 3.85476 0.461358 4.31612 1.03174 4.31612C1.03174 4.31612 1.28877 4.31612 1.28877 4.31612C1.85915 4.31612 2.32051 3.85476 2.32051 3.28438C2.32051 3.28438 2.32051 1.03174 2.32051 1.03174C2.32051 0.461358 1.85915 0 1.28877 0C1.28877 0 1.03174 0 1.03174 0C0.461358 0 0 0.461358 0 1.03174C0 1.03174 0 3.28438 0 3.28438C0 3.28438 0 3.28438 0 3.28438Z",
    fill: "#F3FCFF",
    fillRule: "evenodd",
    fillOpacity: 0.9
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.809 5.813)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 16.816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.235373 0C0.235373 0 0.235373 0.00288862 0.235373 0.00288862C0.290967 0.746548 0.272196 1.2765 0.17978 1.62017C0.17978 1.62017 0.148734 1.74074 0.148734 1.74074C0.0808659 2.00066 0.0808659 2.00066 0.0281591 2.13712C0.0281591 2.13712 0 2.21149 0 2.21149L0.1083 2.2086C0.1083 2.2086 0.123462 2.17466 0.123462 2.17466C0.179055 2.03532 0.179055 2.03532 0.250535 1.7689C0.250535 1.7689 0.28158 1.64833 0.28158 1.64833C0.377605 1.28588 0.396379 0.762432 0.340785 0C0.340785 0 0.235373 0 0.235373 0L0.235373 0L0.235373 0Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "translate(9.945 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.136434 0C0.136434 0 0.136434 0.00288862 0.136434 0.00288862C0.0808394 0.746548 0.0996121 1.2765 0.192028 1.62017C0.192028 1.62017 0.223073 1.74074 0.223073 1.74074C0.290942 2.00066 0.290942 2.00066 0.343647 2.13712C0.343647 2.13712 0.371805 2.21149 0.371805 2.21149L0.263505 2.2086C0.263505 2.2086 0.248343 2.17466 0.248343 2.17466C0.192749 2.03532 0.192749 2.03532 0.121271 1.7689C0.121271 1.7689 0.0902258 1.64833 0.0902258 1.64833C-0.00580037 1.28588 -0.024572 0.762432 0.0310212 0C0.0310212 0 0.136434 0 0.136434 0L0.136434 0L0.136434 0Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.055 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.32419 0.0837517C-0.111116 1.64544 0.000793213 4.73993 0.000793213 4.77098C0.000793213 4.77098 0.000793213 4.77386 0.000793213 4.77386C0.000793213 4.77386 0.106206 4.74932 0.106206 4.74932C0.099708 4.48579 0.0910432 1.40646 2.66858 0C2.66858 0 2.52274 0.0339341 2.52274 0.0339341L2.32419 0.0837517C2.32419 0.0837517 2.32419 0.0837517 2.32419 0.0837517Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.344393 0.0837517C2.7797 1.64544 2.66779 4.73993 2.66779 4.77098C2.66779 4.77098 2.66779 4.77386 2.66779 4.77386C2.66779 4.77386 2.56238 4.74932 2.56238 4.74932C2.56888 4.48579 2.57754 1.40646 0 0C0 0 0.145843 0.0339341 0.145843 0.0339341L0.344393 0.0837517C0.344393 0.0837517 0.344393 0.0837517 0.344393 0.0837517Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "translate(7.531 0)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthiquinAvatar);
export default __webpack_public_path__ + "static/media/ethiquin_avatar.31b802dda7d359f919353152ec5ae380.svg";
export { ForwardRef as ReactComponent };